module.exports = __webpack_public_path__ + "static/favicon-88c17461cd19d1b89a4fb551a21712ec.ico";